import { isWX } from "@/plugins/untils";
import { getWxGetShareData } from "@/network/api";
import { Toast } from "mint-ui";
const wx = require("weixin-js-sdk");
window.wx = wx;
// import wx from "weixin-js-sdk"
// let script;
// if (isWX()) {

// }

function wexinShare({ title = "", desc = "", pic = "", link = "" }) {
  if (!isWX()) return;
  let url = link || window.location.href;
  // alert(url)
  // const config = {
  //   shareTitle: title,
  //   shareTxt: "",
  //   shareUrl: url,
  //   imgUrl: pic,
  // };
  // script && script.parentNode.removeChild(script);
  // getWxGetShareData({ REFERER: url }).then((doc) => {
  //   let head = document.getElementsByTagName("head").item(0);
  //   script = document.createElement("script");
  //   script.setAttribute("type", "text/javascript");
  //   head.appendChild(script);
  //   script.innerHTML = doc;
  //   wxint(config);
  // });
  // console.log(wxint);
  getWxGetShareData({ REFERER: encodeURIComponent(url) }).then((doc) => {
    let debug, appId, timestamp, nonceStr, signature;

    if (/debug:(.*),/.test(doc)) {
      debug = RegExp.$1.trim().split(",")[0] !== "false";
    }
    if (/appId:(.*),/.test(doc)) {
      appId = RegExp.$1
        .trim()
        .split(",")[0]
        .replace("'", "")
        .replace("'", "");
    }
    if (/timestamp:(.*),/.test(doc)) {
      timestamp = RegExp.$1
        .trim()
        .split(",")[0]
        .replaceAll("'", "")
        .replace("'", "");
    }
    if (/nonceStr:(.*),/.test(doc)) {
      nonceStr = RegExp.$1
        .trim()
        .split(",")[0]
        .replaceAll("'", "")
        .replace("'", "");
    }
    if (/signature:(.*),/.test(doc)) {
      signature = RegExp.$1
        .trim()
        .split(",")[0]
        .replaceAll("'", "")
        .replace("'", "");
    }
    // console.log(debug, appId, timestamp, nonceStr, signature);

    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。（测试记得关掉）
      appId, // 必填，公众号的唯一标识
      timestamp, // 必填，生成签名的时间戳
      nonceStr, // 必填，生成签名的随机串
      signature, // 必填，签名，见附录1
      jsApiList: [
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "checkJsApi",
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
        "onMenuShareQQ",
        "onMenuShareWeibo",
        "chooseImage",
        "previewImage",
        "uploadImage",
        "downloadImage",
        "startRecord",
        "stopRecord",
      ], // 必填，需要使用的JS接口列表
    });
    wx.ready(function() {
      // //分享到朋友圈”及“分享到QQ空间”
      wx.updateTimelineShareData({
        title, // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: pic, // 分享图标
        success: function() {},
        cancel: function() {},
      });

      //“分享给朋友”及“分享到QQ”
      wx.updateAppMessageShareData({
        title, // 分享标题
        desc, // 分享描述
        link: url, // 分享链接 该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: pic, // 分享图标
        success: function() {},
        cancel: function() {},
      });

      wx.onMenuShareTimeline({
        title,
        link: url,
        imgUrl: pic,
        success: function() {},
        cancel: function() {},
      });
      wx.onMenuShareAppMessage({
        title,
        desc,
        link: url,
        imgUrl: pic,
        type: "",
        dataUrl: "",
        success: function() {},
        cancel: function() {},
      });
      wx.onMenuShareQQ({
        title,
        desc: "",
        link: url,
        imgUrl: pic,
        success: function() {},
        cancel: function() {},
      });
      wx.onMenuShareWeibo({
        title,
        desc: "",
        link: url,
        imgUrl: pic,
        success: function() {},
        cancel: function() {},
      });
      // wx.error(function (res) { alert(res.errMsg); });
      // wx.checkJsApi({ jsApiList: ['getNetworkType', 'previewImage'], success: function (res) { } });
    });
  });
}
export default wexinShare;
